<script lang="ts">
    import AppLayout from '@/layouts/AppLayout.svelte';
    import GuidesLayout from '@/layouts/guides/Layout.svelte';
    import { type BreadcrumbItem } from '@/types';

    interface Guide {
        slug: string;
        title: string;
        description: string;
        icon: string;
    }

    interface Props {
        guide: Guide;
        content: string;
        guides: Guide[];
    }

    let { guide, content, guides }: Props = $props();

    const breadcrumbItems: BreadcrumbItem[] = [
        {
            title: 'Guides',
            href: '/guides',
        },
        {
            title: guide.title,
            href: `/guides/${guide.slug}`,
        },
    ];
</script>

<svelte:head>
    <title>{guide.title}</title>
</svelte:head>

<AppLayout breadcrumbs={breadcrumbItems}>
    <GuidesLayout {guides}>
        <article class="prose prose-neutral dark:prose-invert max-w-none">
            {@html content}
        </article>
    </GuidesLayout>
</AppLayout>